import { render, staticRenderFns } from "./RoleDataTableRow.vue?vue&type=template&id=472dd1a0&"
import script from "./RoleDataTableRow.vue?vue&type=script&lang=js&"
export * from "./RoleDataTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports